import React, { useState, useEffect } from 'react';

export default function DisclaimerModal() {
  const [isOpen, setIsOpen] = useState(true);

  const handleAccept = () => {
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 9999,
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'white', borderRadius: '12px', padding: '30px',
        maxWidth: '500px', width: '100%', boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
        position: 'relative', animation: 'fadeIn 0.3s ease'
      }}>
        <h2 style={{ color: '#d32f2f', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
          ⚠️ Notificare Legală Importantă
        </h2>
        
        <p style={{ fontSize: '15px', lineHeight: '1.6', color: '#333' }}>
          Această aplicație este o platformă <strong>strict orientativă</strong>, dezvoltată pe baza <em>Legii nr. 448/2006</em> și a criteriilor aprobate prin lege.
        </p>
        
        <div style={{ background: '#fff3cd', borderLeft: '4px solid #ffc107', padding: '15px', margin: '20px 0', fontSize: '14px', color: '#856404' }}>
          <strong>Atenție!</strong> Rezultatul obținut aici <strong>NU ține loc de document oficial</strong> și nu garantează decizia Comisiei. Încadrarea oficială în grad de handicap se face <strong>exclusiv</strong> de către Comisia de Evaluare a Persoanelor Adulte cu Handicap din cadrul DGASPC, în urma depunerii dosarului fizic și a evaluării medicale și psihosociale.
        </div>

        <button 
          onClick={handleAccept}
          style={{
            width: '100%', padding: '12px', background: '#2c3e50', color: 'white',
            border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: 'bold',
            cursor: 'pointer', transition: 'background 0.2s'
          }}
          onMouseOver={(e) => e.target.style.background = '#1a252f'}
          onMouseOut={(e) => e.target.style.background = '#2c3e50'}
        >
          Am înțeles, continuă spre aplicație
        </button>
      </div>
    </div>
  );
}
